import fetch from 'node-fetch';

const fetchMiddleware = store => next => action => {
  if (!action || !action.fetchConfig) {
    return next(action);
  }
  const dispatch = store.dispatch;
  const config = action.fetchConfig;
  const host = config.host;
  const path = config.path;
  const method = config.method;
  const queryParams = config.queryParams;
  var headers = config.headers;
  const successHandler = config.success;
  const errorHandler = config.error;
  const start = config.start;
  const body = config.body;
  const additionalSuccessHandlers = config.additionalSuccessHandlers;

  let url = path;

  if (host) url += path;

  if (queryParams) {
    url = `${url}?${queryParams}`;
  }
  const fetchData = {
    method,
    headers,
    body
  };

  if (start) {
    dispatch(start());
  }

  fetch(url, fetchData)
    .then(response => {
      if (response.ok) {
        response.json().then(data => {
          if (successHandler) {
            dispatch(successHandler(data, config));
          }

          if (additionalSuccessHandlers) {
            for (let i in additionalSuccessHandlers) {
              let handler = additionalSuccessHandlers[i];
              dispatch(handler['method'](...handler['args']));
            }
          }
        });
      } else if (errorHandler) {
        response.json().then(data => {
          dispatch(errorHandler(data, config));
        });
      }
    })
    .catch(error => {});
};

export default fetchMiddleware;
